<template>
  <div v-if="showTextField" :class="['campaign-box-text-field', bgColourClass]">
    <h2 v-if="showTitle" data-test-campaign-box-text-field-title v-html="title" />
    <div v-if="showText" data-test-campaign-box-text-field-text v-html="text" />
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'TextField',
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    },
    text: {
      type: String,
      default() {
        return '';
      }
    },
    bgColourClass: {
      type: String,
      default() {
        return 'site-primary-color';
      }
    }
  },
  computed: {
    showTextField(): boolean {
      return this.title !== '' || this.text !== '';
    },
    showTitle(): boolean {
      return this.title !== '';
    },
    showText(): boolean {
      return this.text !== '';
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';
.campaign-box-text-field {
  color: $white;
  padding: rem-calc(23);
  text-align: center;
  position: relative;

  h2 {
    font-size: rem-calc(38);
    color: $white;
  }

  &.site-primary-color {
    background-color: $primary-color;
  }

  &.site-secondary-color {
    background-color: $disturber-color;
  }
}
</style>
